module.exports = __webpack_public_path__ + "img/logo_goso.f29bf9b7.png";